var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Navigation'),_c('v-main',[_c('Hero'),_c('Solutions'),_c('EnterpriseSMS'),_c('Services'),_c('GoodbyeNumbers'),_c('Capabilities'),_c('Testimonials'),_c('CallToAction'),_c('PageFooter')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }